module.exports = __webpack_public_path__ + "img/pexels-photo-886465.aceb2ff6.jpg";